(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7345],{

/***/ 78741:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return __webpack_require__(43776);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FieldValidationError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);






function FieldValidationError(_param) {
    var meta = _param.meta, css = _param.css, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "meta",
        "css"
    ]);
    if (meta.touched && (meta.error || meta.submitError)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            css: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                marginLeft: "auto",
                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .red */ .Q6,
                textTransform: "uppercase",
                fontSize: 12
            }, css)
        }, props), {
            children: meta.error || meta.submitError
        }));
    }
    return null;
};


/***/ }),

/***/ 83378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BackToTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81031);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67459);







function BackToTop() {
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showScroll = ref[0], setShowScroll = ref[1];
    var checkScrollTop = function() {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true);
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false);
        }
    };
    var scrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", checkScrollTop);
        return function() {
            window.removeEventListener("scroll", checkScrollTop);
        };
    }, [
        showScroll
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        "aria-hidden": showScroll === false,
        style: {
            display: showScroll ? "flex" : "none"
        },
        css: {
            position: "fixed",
            right: 24,
            bottom:  true ? 160 : 0,
            zIndex: 9999,
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("button", {
            type: "button",
            onClick: scrollTop,
            tabIndex: -1,
            "aria-label": "Back to top",
            css: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                margin: 0,
                padding: 0,
                color: _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .palette.white */ .DG.white,
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                border: "none",
                borderRadius: "100%",
                outline: "none",
                cursor: "pointer",
                appearance: "none",
                userSelect: "none",
                "&:hover": {
                    backgroundColor: _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .palette.blue[500] */ .DG.blue[500],
                    boxShadow: "0 1px 8px 0 #33333366",
                    transition: "box-shadow 60ms ease 0s",
                    animation: "".concat(wiggle, " 1.2s ease"),
                    animationIterationCount: 1
                },
                WebkitAppearance: "none"
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ArrowUp, {
                width: 32,
                height: 32,
                display: "flex"
            })
        })
    });
};
var ArrowUp = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: 32,
        height: 32,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            d: "M12 19V5M5 12l7-7 7 7"
        })
    }));
};
var wiggle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)("20%{transform:translateY(6px);}40%{transform:translateY(-6px);}60%{transform:translateY(4px);}80%{transform:translateY(-2px);}100%{transform:translateY(0);}");


/***/ }),

/***/ 91760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ stripUndefined; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56365);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

function stripUndefined(values) {
    return lodash_fp__WEBPACK_IMPORTED_MODULE_0___default().pickBy((lodash_fp__WEBPACK_IMPORTED_MODULE_0___default().identity), values);
};


/***/ }),

/***/ 32774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ validate; }
/* harmony export */ });
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35494);
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_set__WEBPACK_IMPORTED_MODULE_0__);

function validate(schema) {
    return function(values) {
        try {
            schema.validateSync(values, {
                abortEarly: false
            });
            return {};
        } catch (e) {
            return e.inner.reduce(function(errors, error) {
                if (typeof error.path !== "undefined") {
                    return lodash_fp_set__WEBPACK_IMPORTED_MODULE_0___default()(error.path, error.message, errors);
                }
            }, {});
        }
    };
};


/***/ }),

/***/ 43776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductsPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/index.ts + 23 modules
var _govlaunch_product = __webpack_require__(74047);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(81871);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(22913);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/form/resources/ShowMoreButtonWithIcon.tsx + 1 modules
var ShowMoreButtonWithIcon = __webpack_require__(38248);
// EXTERNAL MODULE: ./components/qol/BackToTop.tsx
var BackToTop = __webpack_require__(83378);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/ProductsPageSeo.tsx




function ProductsPageSeo() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
        title: intl.formatMessage({
            defaultMessage: "Local Government Technology Products – Govlaunch",
            id: "ns3WLU"
        }),
        description: intl.formatMessage({
            defaultMessage: "Search local government technology products used by communities around the world.",
            id: "MHjRHx"
        })
    });
};

// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./src/shared/components/NoResultsFound.tsx
var NoResultsFound = __webpack_require__(57600);
// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
// EXTERNAL MODULE: ./src/components/translation/TranslationButton.tsx
var TranslationButton = __webpack_require__(98769);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/components/product/graphql/SearchProductsQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SearchProducts($tags: [String!], $name: String, $limit: Int, $cursor: Cursor) {\n    searchProducts(tags: $tags, name: $name, limit: $limit, cursor: $cursor) {\n      items {\n        ...ProductCardFields\n      }\n      pageInfo {\n        startCursor\n        endCursor\n        hasPreviousPage\n        hasNextPage\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var SearchProductsQuery = ((0,lib/* gql */.Ps)(_templateObject(), _govlaunch_product/* ProductCardFieldsFragment */.Bl));

// EXTERNAL MODULE: ./src/components/product/graphql/ToggleProductStackMutation.ts
var ToggleProductStackMutation = __webpack_require__(91369);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/debounce.js
var debounce = __webpack_require__(6989);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./lib/utils/stripUndefined.ts
var stripUndefined = __webpack_require__(91760);
// EXTERNAL MODULE: ./src/shared/components/TagsFilterSelect.tsx
var TagsFilterSelect = __webpack_require__(83353);
// EXTERNAL MODULE: ./src/shared/hooks/useTagsFilter.tsx + 1 modules
var useTagsFilter = __webpack_require__(32025);
// EXTERNAL MODULE: ./src/utils/nextLinkHref.ts
var nextLinkHref = __webpack_require__(88196);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./src/components/product/ProductsListingPageFilters.tsx













function ProductsListingPageFilters() {
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var variables = {
        name: (0,stringOrFirst/* default */.Z)(router.query.name),
        tagSlugs: Array.isArray(router.query.tags) ? router.query.tags : router.query.tags ? [
            router.query.tags
        ] : []
    };
    var initialTagSlugs = (0,react.useRef)(variables.tagSlugs);
    var ref = (0,useTagsFilter/* default */.Z)({
        tags: initialTagSlugs.current
    }), loading = ref.loading, tags = ref.tags;
    var ref1 = (0,react.useState)(tags), tagOptions = ref1[0], setTagOptions = ref1[1];
    var commitSearch = (0,react.useCallback)(function(searchQuery) {
        router.push({
            pathname: router.pathname,
            query: (0,stripUndefined/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                name: searchQuery
            }))
        });
    }, []);
    var performSearch = (0,react.useCallback)(debounce_default()(400, function(searchQuery) {
        commitSearch(searchQuery);
    }), []);
    if (loading) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                gridTemplateColumns: [
                    "1fr",
                    "1fr",
                    "max-content 1fr 1fr",
                    "max-content 1fr 1fr"
                ],
                pb: [
                    0,
                    0,
                    4
                ],
                borderBottom: [
                    "none",
                    "none",
                    "1px solid #ADB6C3"
                ],
                spacing: 4,
                mb: 6,
                borderBottomColor: "gray.300",
                mt: 6,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                        color: "gray.0",
                        textTransform: "uppercase",
                        fontSize: "2xl",
                        as: "h1",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Products",
                            id: "7NFfmz"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsFilterSelect/* default */.Z, {
                        tagTypes: [
                            "PRODUCT"
                        ],
                        disabled: loading,
                        selectedItems: tagOptions,
                        onChange: function(tags) {
                            setTagOptions(tags);
                            router.push((0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                                tags: tags.map(function(tag) {
                                    return tag.value;
                                })
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Input */.II, {
                        "aria-label": intl.formatMessage({
                            defaultMessage: "Product search",
                            id: "xMxkKr"
                        }),
                        size: "sm",
                        placeholder: intl.formatMessage({
                            defaultMessage: "Search for a product...",
                            id: "ryBIxb"
                        }),
                        defaultValue: variables.name,
                        onChange: function(event) {
                            performSearch(event.target.value);
                        }
                    })
                ]
            }),
            tagOptions.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                mt: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: tagOptions.filter(function(tag) {
                        return variables.tagSlugs.includes(tag.value);
                    }).map(function(tag) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Tag */.Vp, {
                            selected: true,
                            mr: 3,
                            mb: 2,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* TagText */.ys, {
                                    children: tag.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* TagCloseButton */.SD, {
                                    onClick: function() {
                                        var filteredTags = tagOptions.filter(function(candidate) {
                                            return candidate.value !== tag.value;
                                        });
                                        setTagOptions(filteredTags);
                                        router.push((0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                                            tags: filteredTags.map(function(tag) {
                                                return tag.value;
                                            })
                                        }));
                                    }
                                })
                            ]
                        }, tag.value);
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(99951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(48465);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(20597);
;// CONCATENATED MODULE: ./components/product/marketplace/ProductWasSuggestedMessage.tsx






var ProductWasSuggestedMessage = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimedRender, {
        ms: 5000,
        children: function(expired) {
            if (expired) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                css: {
                    fontSize: 12,
                    fontWeight: "normal",
                    color: "#21926a"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Thanks for the suggestion!",
                    id: "3gYDNc"
                })
            });
        }
    });
};
var TimedRender = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(TimedRender, Component);
    var _super = (0,_create_super/* default */.Z)(TimedRender);
    function TimedRender(props) {
        (0,_class_call_check/* default */.Z)(this, TimedRender);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            expired: false
        };
        _this.timeout = setTimeout(function() {
            _this.setState({
                expired: true
            });
        }, _this.props.ms);
        return _this;
    }
    var _proto = TimedRender.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        clearTimeout(this.timeout);
    };
    _proto.render = function render() {
        return this.props.children(this.state.expired);
    };
    return TimedRender;
}(react.Component);
/* harmony default export */ var marketplace_ProductWasSuggestedMessage = (ProductWasSuggestedMessage);

// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38975);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
;// CONCATENATED MODULE: ./lib/mutations/SuggestProduct.ts

function SuggestProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SuggestProduct($name: String!, $url: String) {\n    suggestProduct(name: $name, url: $url) {\n      _id\n      name\n      url\n    }\n  }\n"
    ]);
    SuggestProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SuggestProduct = ((0,lib/* gql */.Ps)(SuggestProduct_templateObject()));

// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/final-form@4.20.7/node_modules/final-form/dist/final-form.es.js
var final_form_es = __webpack_require__(60681);
// EXTERNAL MODULE: ./components/form/FieldValidationError.tsx
var FieldValidationError = __webpack_require__(80360);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/utils/index.ts
var utils = __webpack_require__(20682);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
;// CONCATENATED MODULE: ./components/product/marketplace/SuggestProductPopoverDesktop.tsx




















function SuggestProductPopoverDesktop(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, onSuggestProduct = param.onSuggestProduct, children = param.children;
    var intl = (0,useIntl/* default */.Z)();
    var productSuggestionValidation = es/* object */.Ry().shape({
        name: es/* string */.Z_().required(intl.formatMessage({
            defaultMessage: "Can't be blank",
            id: "Bom3o3"
        })),
        url: es/* string */.Z_().url(intl.formatMessage({
            defaultMessage: "Invalid URL",
            id: "SASA4f"
        }))
    });
    var maxProductSuggestions = intl.formatMessage({
        defaultMessage: "You've reached the limit of 50 product suggestions per day",
        id: "Hbm59/",
        description: "Error message for when a user reaches the limit of product suggestions"
    });
    var couldntAddProductSuggestion = intl.formatMessage({
        defaultMessage: "Could not add product suggestion",
        id: "+FLj1P"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
        placement: "bottom",
        onClickOutside: function() {
            onRequestClose();
        },
        isOpen: isOpen,
        boxStyle: {
            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)"
        },
        render: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: SuggestProduct,
                children: function(suggestProduct) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                        onSubmit: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.prev = 0;
                                            _ctx.next = 3;
                                            return suggestProduct({
                                                variables: data
                                            });
                                        case 3:
                                            onSuggestProduct();
                                            _ctx.next = 11;
                                            break;
                                        case 6:
                                            _ctx.prev = 6;
                                            _ctx.t0 = _ctx["catch"](0);
                                            if (!/maximum number of product suggestions/i.test(_ctx.t0.message)) {
                                                _ctx.next = 10;
                                                break;
                                            }
                                            return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, maxProductSuggestions));
                                        case 10:
                                            return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, couldntAddProductSuggestion));
                                        case 11:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        0,
                                        6
                                    ]
                                ]);
                            }));
                            return function(data) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        validate: (0,validate/* default */.Z)(productSuggestionValidation),
                        children: function(param) {
                            var handleSubmit = param.handleSubmit, invalid = param.invalid, submitError = param.submitError;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                                onSubmit: handleSubmit,
                                autoComplete: "off",
                                css: {
                                    padding: "16px 24px 12px 24px",
                                    display: "flex",
                                    flexDirection: "column",
                                    minWidth: 576,
                                    novalidate: true
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* KeyboardEscapeListener */.zz, {
                                        onEscape: onRequestClose
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                mb: 16,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                            mb: 8,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                                css: {
                                                                    fontSize: 24,
                                                                    fontWeight: 700,
                                                                    color: "#086BE5"
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                    defaultMessage: "See something missing?",
                                                                    id: "RUHglt"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                            css: {
                                                                fontSize: 16,
                                                                fontWeight: 600,
                                                                color: palette/* darkGray */.O5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Help us improve our marketplace, submit your suggestion!",
                                                                id: "4FU9ZP"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                onClick: onRequestClose,
                                                role: "button",
                                                "aria-label": "Close",
                                                css: {
                                                    "&:hover": {
                                                        color: palette/* mediumGray */.rF
                                                    },
                                                    marginLeft: "auto",
                                                    color: palette/* sealBlue */.N9,
                                                    fontWeight: 500,
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        border: "solid 1px #ADB6C3",
                                                        borderRadius: 25,
                                                        height: 24,
                                                        width: 24,
                                                        background: "#ADB6C3"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            fontSize: 30,
                                                            color: palette/* white */.ix
                                                        },
                                                        children: "\xd7"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                        name: "name",
                                        children: function(param) {
                                            var input = param.input, meta = param.meta;
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                                mb: 16,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                                        placeholder: intl.formatMessage({
                                                            defaultMessage: "Product name",
                                                            id: "rs6XNw"
                                                        }),
                                                        type: "text",
                                                        css: {
                                                            ":focus": {
                                                                borderColor: palette/* darkSkyBlue */.Gf
                                                            },
                                                            height: 32,
                                                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                                            borderRadius: 3,
                                                            outline: "none",
                                                            width: "100%",
                                                            fontSize: 14,
                                                            minWidth: 576,
                                                            paddingLeft: 16,
                                                            paddingTop: 6,
                                                            paddingBottom: 6
                                                        }
                                                    })),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                        meta: meta,
                                                        css: {
                                                            marginTop: 6
                                                        }
                                                    })
                                                ]
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                        name: "url",
                                        children: function(param) {
                                            var input = param.input, meta = param.meta;
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                                mb: 16,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                                        placeholder: intl.formatMessage({
                                                            defaultMessage: "Paste a link to this product (optional)",
                                                            id: "qeOI5p"
                                                        }),
                                                        css: {
                                                            ":focus": {
                                                                borderColor: palette/* darkSkyBlue */.Gf
                                                            },
                                                            type: "url",
                                                            height: 32,
                                                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                                            borderRadius: 3,
                                                            outline: "none",
                                                            width: "100%",
                                                            fontSize: 14,
                                                            minWidth: 576,
                                                            paddingLeft: 16,
                                                            paddingTop: 6,
                                                            paddingBottom: 6
                                                        },
                                                        onBlur: function(event) {
                                                            var url = event.target.value.trim();
                                                            url = (0,utils/* prefixWithHttpIfNecessary */.KI)(url, true) || "";
                                                            input.onChange(url);
                                                        }
                                                    })),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                        meta: meta,
                                                        css: {
                                                            marginTop: 6
                                                        }
                                                    })
                                                ]
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                type: "submit",
                                                theme: "primary",
                                                color: "#086BE5",
                                                textColor: "#ffffff",
                                                disabled: invalid,
                                                css: {
                                                    width: "100%",
                                                    marginRight: 10,
                                                    ":disabled": {
                                                        opacity: 0.8
                                                    },
                                                    fontSize: 16,
                                                    fontWeight: 600,
                                                    borderRadius: 3,
                                                    height: 40
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Suggest Product",
                                                    id: "ofg0+9"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                theme: "secondary",
                                                color: "#3F4A5A",
                                                css: {
                                                    width: "100%",
                                                    marginLeft: 10,
                                                    fontSize: 16,
                                                    fontWeight: 600,
                                                    borderColor: "#ADB6C3",
                                                    borderRadius: 3,
                                                    height: 40
                                                },
                                                onClick: onRequestClose,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Cancel",
                                                    id: "47FYwb"
                                                })
                                            })
                                        ]
                                    }),
                                    submitError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 8,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                color: palette/* red */.Q6,
                                                fontSize: 14
                                            },
                                            children: submitError
                                        })
                                    })
                                ]
                            });
                        }
                    });
                }
            });
        },
        children: function(popoverProps) {
            return children(popoverProps);
        }
    });
};

// EXTERNAL MODULE: ./components/mobile/index.tsx
var mobile = __webpack_require__(31772);
;// CONCATENATED MODULE: ./components/product/marketplace/SuggestProductPopoverMobile.tsx



















function SuggestProductPopoverMobile(param) {
    var onRequestClose = param.onRequestClose, onSuggestProduct = param.onSuggestProduct;
    var intl = (0,useIntl/* default */.Z)();
    var productSuggestionValidation = es/* object */.Ry().shape({
        name: es/* string */.Z_().required(intl.formatMessage({
            defaultMessage: "Can't be blank",
            id: "Bom3o3"
        })),
        url: es/* string */.Z_().url(intl.formatMessage({
            defaultMessage: "Invalid URL",
            id: "SASA4f"
        }))
    });
    var maxProductSuggestions = intl.formatMessage({
        defaultMessage: "You've reached the limit of 50 product suggestions per day",
        id: "Hbm59/",
        description: "Error message for when a user reaches the limit of product suggestions"
    });
    var couldntAddProductSuggestion = intl.formatMessage({
        defaultMessage: "Could not add product suggestion",
        id: "+FLj1P"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreen */.vp, {
        isOpen: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreenHeader */.uD, {
                    onRequestClose: onRequestClose,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Product suggestion",
                        id: "DrBFWv"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(mobile/* MobileScreenBody */.Ly, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mb: 20,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mb: 3,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            css: {
                                                fontSize: 16,
                                                fontWeight: 600,
                                                color: "#086BE5"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "See something missing?",
                                                id: "RUHglt"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            color: palette/* mediumGray */.rF,
                                            fontSize: 12
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Help us improve our marketplace, submit your suggestion!",
                                            id: "4FU9ZP"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                            mutation: SuggestProduct,
                            children: function(suggestProduct) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                                    onSubmit: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                while(1)switch(_ctx.prev = _ctx.next){
                                                    case 0:
                                                        _ctx.prev = 0;
                                                        _ctx.next = 3;
                                                        return suggestProduct({
                                                            variables: data
                                                        });
                                                    case 3:
                                                        onSuggestProduct();
                                                        _ctx.next = 11;
                                                        break;
                                                    case 6:
                                                        _ctx.prev = 6;
                                                        _ctx.t0 = _ctx["catch"](0);
                                                        if (!/maximum number of product suggestions/i.test(_ctx.t0.message)) {
                                                            _ctx.next = 10;
                                                            break;
                                                        }
                                                        return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, maxProductSuggestions));
                                                    case 10:
                                                        return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, couldntAddProductSuggestion));
                                                    case 11:
                                                    case "end":
                                                        return _ctx.stop();
                                                }
                                            }, _callee, null, [
                                                [
                                                    0,
                                                    6
                                                ]
                                            ]);
                                        }));
                                        return function(data) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    validate: (0,validate/* default */.Z)(productSuggestionValidation),
                                    children: function(param) {
                                        var handleSubmit = param.handleSubmit, invalid = param.invalid, submitError = param.submitError;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                                            onSubmit: handleSubmit,
                                            autoComplete: "off",
                                            css: {
                                                display: "flex",
                                                flexDirection: "column",
                                                novalidate: true
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                    name: "name",
                                                    children: function(param) {
                                                        var input = param.input, meta = param.meta;
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                                            mb: 20,
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                                                    placeholder: intl.formatMessage({
                                                                        defaultMessage: "Product name",
                                                                        id: "rs6XNw"
                                                                    }),
                                                                    type: "text",
                                                                    css: {
                                                                        ":focus": {
                                                                            borderColor: palette/* darkSkyBlue */.Gf
                                                                        },
                                                                        height: 50,
                                                                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                                                        borderRadius: 4,
                                                                        padding: "0 15px",
                                                                        outline: "none",
                                                                        width: "100%"
                                                                    }
                                                                })),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                                    meta: meta
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                    name: "url",
                                                    children: function(param) {
                                                        var input = param.input, meta = param.meta;
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                                            mb: 20,
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                                                    placeholder: intl.formatMessage({
                                                                        defaultMessage: "Paste a link to this product (optional)",
                                                                        id: "qeOI5p"
                                                                    }),
                                                                    css: {
                                                                        ":focus": {
                                                                            borderColor: palette/* darkSkyBlue */.Gf
                                                                        },
                                                                        type: "url",
                                                                        height: 50,
                                                                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                                                        borderRadius: 4,
                                                                        marginBottom: 20,
                                                                        padding: "0 15px",
                                                                        outline: "none",
                                                                        width: "100%"
                                                                    }
                                                                })),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                                    meta: meta
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        display: "flex"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                            type: "submit",
                                                            theme: "primary",
                                                            color: "#086BE5",
                                                            textColor: "#ffffff",
                                                            disabled: invalid,
                                                            css: {
                                                                width: "100%",
                                                                marginRight: 10,
                                                                ":disabled": {
                                                                    opacity: 0.8
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Suggest Product",
                                                                id: "ofg0+9"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                            theme: "secondary",
                                                            color: "#3F4A5A",
                                                            css: {
                                                                marginLeft: 10,
                                                                width: "100%",
                                                                borderColor: "#ADB6C3"
                                                            },
                                                            onClick: onRequestClose,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Cancel",
                                                                id: "47FYwb"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                submitError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                    mt: 8,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        css: {
                                                            color: palette/* red */.Q6,
                                                            fontSize: 14
                                                        },
                                                        children: submitError
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/product/marketplace/SuggestProductPopover.tsx





function SuggestProductPopover(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, onSuggestProduct = param.onSuggestProduct, children = param.children;
    var isMobile = (0,useIsMobile/* default */.Z)();
    if (isOpen && isMobile) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestProductPopoverMobile, {
            onRequestClose: onRequestClose,
            onSuggestProduct: onSuggestProduct
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestProductPopoverDesktop, {
        isOpen: isOpen && !isMobile,
        onRequestClose: onRequestClose,
        onSuggestProduct: onSuggestProduct,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/product/icons/GovernmentsStackIcon.tsx





function GovernmentsStackIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SvgBox */.$C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 12,
                cy: 12,
                r: 10.75,
                fill: "#fff",
                stroke: "#3F4A5A",
                strokeWidth: 2.5
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                id: "fa4wiuwai4wau4",
                fill: "#fff",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 5.539,
                    y: 8.308,
                    width: 12.923,
                    height: 9.231,
                    rx: 1
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                x: 5.539,
                y: 8.308,
                width: 12.923,
                height: 9.231,
                rx: 1,
                fill: "#fff",
                stroke: "#3F4A5A",
                strokeWidth: 3.4,
                mask: "url(#fa4wiuwai4wau4)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                stroke: "#3F4A5A",
                strokeLinecap: "round",
                d: "M7.885 6.885h8.231M9.731 5.038h4.538"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/product/icons/SavedProductsIcon.tsx





function SavedProductsIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SvgBox */.$C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 12,
                cy: 12,
                r: 10.75,
                fill: "#fff",
                stroke: "#3F4A5A",
                strokeWidth: 2.5
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.274 7.382c-.476 0-.836.326-.836.694v9.165L12 14.224l3.562 3.017V8.076c0-.368-.36-.694-.836-.694H9.274zm-1.89.694c0-.905.864-1.614 1.89-1.614h5.452c1.026 0 1.89.71 1.89 1.614v9.694c0 .396-.374.692-.8.692h0a.87.87 0 01-.557-.196l-.002-.002L12 15.506l-3.255 2.757h-.001a.891.891 0 01-.86.147c-.295-.103-.5-.352-.5-.64V8.076z",
                fill: "#3F4A5A",
                stroke: "#3F4A5A",
                strokeWidth: 0.8
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/product/icons/SuggestProductIcon.tsx





function SuggestProductIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SvgBox */.$C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2451 6.75989H12.7541C13.1584 6.75989 13.4982 7.10006 13.4982 7.50398V10.5011H16.4956C16.8999 10.5011 17.2397 10.8412 17.2397 11.2451V12.7541C17.2397 13.1584 16.8999 13.4982 16.4956 13.4982H13.4982V16.4956C13.4982 16.9211 13.1584 17.2397 12.7541 17.2397H11.2451C10.8412 17.2397 10.5011 16.9211 10.5011 16.4956V13.4982H7.50398C7.07888 13.4982 6.75989 13.1584 6.75989 12.7541V11.2451C6.75989 10.8412 7.07883 10.5011 7.50398 10.5011H10.5011V7.50398C10.5011 7.10011 10.8412 6.75989 11.2451 6.75989ZM12.0108 2.25305C17.3884 2.25305 21.7466 6.61087 21.7466 12.01C21.7466 17.3884 17.3884 21.7466 12.0108 21.7466C6.61088 21.7466 2.25305 17.3884 2.25305 12.01C2.25305 6.61087 6.61088 2.25305 12.0108 2.25305ZM24 12.0101C24 5.37797 18.6217 0 12.0108 0C5.37797 0 0 5.37797 0 12.0101C0 18.6217 5.37797 24 12.0108 24C18.6217 24 24 18.6217 24 12.0101Z",
            fill: "#3F4A5A"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/product/ProductsListingPageHeader.tsx














function ProductsListingPageHeader() {
    var viewer = (0,Auth/* useSelfie */.yD)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), productWasSuggested = ref[0], toggleProductWasSuggested = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isSuggestProductOpen = ref1[0], toggleSuggestProductPopover = ref1[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageContainer */._z, {
                my: 3,
                children: [
                    viewer && (viewer.__typename === "GovernmentUser" || viewer.__typename === "PendingUser" && viewer.verified) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestProductPopover, {
                        isOpen: isSuggestProductOpen,
                        onRequestClose: toggleSuggestProductPopover,
                        onSuggestProduct: function() {
                            toggleProductWasSuggested(true);
                            toggleSuggestProductPopover();
                        },
                        children: function(param) {
                            var innerRef = param.innerRef;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                ref: innerRef,
                                leftIcon: SuggestProductIcon,
                                onClick: function() {
                                    if (!isSuggestProductOpen) {
                                        toggleProductWasSuggested(false);
                                    }
                                    toggleSuggestProductPopover();
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Suggest Product",
                                    id: "ofg0+9"
                                })
                            });
                        }
                    }),
                    viewer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: (0,nextLinkHref/* default */.Z)("/user", {
                            userSlug: viewer.slug,
                            tab: "saved",
                            subtab: "products"
                        }),
                        as: "/@".concat(viewer.slug, "/saved?tab=products"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            leftIcon: SavedProductsIcon,
                            as: "a",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Saved Products",
                                id: "nvxvwL"
                            })
                        })
                    }),
                    viewer && viewer.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: (0,nextLinkHref/* default */.Z)("/government", {
                            governmentSlug: viewer.government.slug,
                            content: "products"
                        }),
                        as: "/governments/".concat(viewer.government.slug, "/products"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            leftIcon: GovernmentsStackIcon,
                            as: "a",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Government Stack",
                                id: "8ZSgve"
                            })
                        })
                    })
                ]
            }),
            productWasSuggested && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageContainer */._z, {
                my: 3,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_ProductWasSuggestedMessage, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/product/pages/ProductsListingPage.tsx




























function ProductsListingPage() {
    var ref, ref1, ref2, ref3, ref4;
    var viewer = (0,Auth/* useSelfie */.yD)();
    var ref5 = (0,react.useState)(1), pageCount = ref5[0], setPageCount = ref5[1];
    var router = (0,next_router.useRouter)();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    var variables = {
        name: (0,stringOrFirst/* default */.Z)(router.query.name),
        tags: Array.isArray(router.query.tags) ? router.query.tags : router.query.tags ? [
            router.query.tags
        ] : [],
        cursor: null,
        limit: 24
    };
    var ref6 = (0,useQuery/* useQuery */.a)(SearchProductsQuery, {
        variables: variables,
        notifyOnNetworkStatusChange: true
    }), loading = ref6.loading, data = ref6.data, fetchMore = ref6.fetchMore, networkStatus = ref6.networkStatus;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleProductStackMutation/* default */.Z), 1), toggleProductStack = ref7[0];
    var onClickLoadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return fetchMore({
                            variables: {
                                cursor: data === null || data === void 0 ? void 0 : (ref = data.searchProducts) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor
                            },
                            updateQuery: function(previousQueryResult, param) {
                                var fetchMoreResult = param.fetchMoreResult;
                                var ref;
                                if (!(fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.searchProducts)) {
                                    return previousQueryResult;
                                }
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult), {
                                    searchProducts: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.searchProducts), {
                                        items: (0,_to_consumable_array/* default */.Z)(((ref = previousQueryResult.searchProducts) === null || ref === void 0 ? void 0 : ref.items) || []).concat((0,_to_consumable_array/* default */.Z)(fetchMoreResult.searchProducts.items || []))
                                    })
                                });
                            }
                        });
                    case 3:
                        setPageCount(pageCount + 1);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickLoadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsPageSeo, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Box */.xu, {
                pb: 24,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsListingPageFilters, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsListingPageHeader, {}),
                    (data === null || data === void 0 ? void 0 : (ref = data.searchProducts) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageContainer */._z, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoResultsFound/* default */.Z, {
                            mt: 32
                        })
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                        columns: [
                            1,
                            1,
                            2,
                            4
                        ],
                        spacingY: 6,
                        children: ((data === null || data === void 0 ? void 0 : (ref2 = data.searchProducts) === null || ref2 === void 0 ? void 0 : ref2.items) || []).map(function(product, index) {
                            var translationLinkWrap = function(slug) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslationButton/* default */.Z, {
                                    paddingY: "4px",
                                    onClick: function(event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        router.push("/products/".concat(slug, "?lang=").concat(locale));
                                    }
                                });
                            };
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/products/".concat(product.slug),
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductCard */.Il, {
                                    "data-intercom-target": index === 0 ? "First product" : undefined,
                                    product: product,
                                    canToggleInStack: viewer ? viewer.__typename === "GovernmentUser" : false,
                                    onToggleInStack: function(product) {
                                        if (viewer && viewer.__typename === "GovernmentUser") {
                                            toggleProductStack({
                                                refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                                    "Government"
                                                ]),
                                                variables: {
                                                    productId: product._id,
                                                    governmentId: viewer.government._id
                                                }
                                            });
                                        }
                                    },
                                    translationLinkWrap: locale !== "en-US" && product.allowRequestTranslation ? translationLinkWrap : undefined
                                })
                            }, product._id);
                        })
                    }),
                    (data === null || data === void 0 ? void 0 : (ref3 = data.searchProducts) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pageInfo) === null || ref4 === void 0 ? void 0 : ref4.hasNextPage) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        justifyContent: "center",
                        mt: 6,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButtonWithIcon/* default */.Z, {
                            onClick: onClickLoadMore,
                            loading: loading && networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackToTop/* default */.Z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./pages/products.tsx



function ProductsPage() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsListingPage, {});
};


/***/ }),

/***/ 91369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleProductStack($governmentId: ObjectId, $productId: ObjectId) {\n    toggleProductStack(governmentId: $governmentId, productId: $productId) {\n      _id\n      inViewerStack\n      governmentsUsingCount\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 98769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TranslationButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90489);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67459);





function TranslationButton(param) {
    var showOriginal = param.showOriginal, onClick = param.onClick, paddingY = param.paddingY;
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
        color: isMobile ? "gray.900" : "blue.600",
        fontSize: isMobile ? "12px" : "14px",
        border: isMobile ? "1px solid #ADB6C3" : "",
        borderRadius: "4px",
        py: paddingY || "8px",
        px: "10px",
        onClick: onClick,
        _hover: {
            cursor: "pointer",
            opacity: 0.5
        },
        role: "button",
        children: showOriginal ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            defaultMessage: "see original",
            id: "/UVQql"
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            defaultMessage: "see translation",
            id: "jJqiqa"
        })
    });
};


/***/ }),

/***/ 83353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TagsFilterSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94614);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49980);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var downshift__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27242);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69057);









function TagsFilterSelect(_param) {
    var handleSelection = function handleSelection(addedItem) {
        if (addedItem) {
            onChange((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(selectedItems).concat([
                addedItem
            ]));
        }
    };
    var tagTypes = _param.tagTypes, onChange = _param.onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, selectedItems = _param.selectedItems, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "tagTypes",
        "onChange",
        "disabled",
        "selectedItems"
    ]);
    var ref = (0,_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .useAlgoliaSearch */ .xY)({
        initialSearchState: {
            index: "tags",
            facetFilters: [
                tagTypes.map(function(tagType) {
                    return "types:".concat(tagType);
                })
            ]
        }
    }), results = ref.results, setSearchState = ref.setSearchState;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(downshift__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        id: "Filter by tags",
        itemToString: function() {
            return "";
        },
        onChange: handleSelection,
        stateReducer: function(_, changes) {
            switch(changes.type){
                case downshift__WEBPACK_IMPORTED_MODULE_6__/* ["default"].stateChangeTypes.controlledPropUpdatedSelectedItem */ .ZP.stateChangeTypes.controlledPropUpdatedSelectedItem:
                    {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, changes), {
                            inputValue: ""
                        });
                    }
                default:
                    return changes;
            }
        },
        selectedItem: selectedItems
    }, props), {
        children: function(param) {
            var getInputProps = param.getInputProps, getMenuProps = param.getMenuProps, getItemProps = param.getItemProps, highlightedIndex = param.highlightedIndex, isOpen = param.isOpen;
            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                "aria-label": "Filter by tags",
                "aria-labelledby": undefined,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        placeholder: intl.formatMessage({
                            defaultMessage: "Filter by tags",
                            id: "r9kS6n"
                        }),
                        disabled: disabled
                    }, getInputProps({
                        size: "sm",
                        "aria-label": "Filter by tags",
                        "aria-labelledby": undefined,
                        onChange: function(e) {
                            var target = e.currentTarget;
                            setSearchState(function(currentState) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, currentState), {
                                    query: target.value
                                });
                            });
                        }
                    }))),
                    isOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                        css: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            position: "absolute",
                            width: "100%",
                            top: 2,
                            left: 0
                        }, getMenuProps({
                            "aria-label": "Filter by Tags",
                            "aria-labelledby": undefined
                        })), {
                            as: "div",
                            zIndex: "dropdown",
                            boxShadow: "lg",
                            border: "1px solid",
                            borderColor: "gray.200",
                            bg: "white",
                            listStyleType: "none",
                            maxHeight: 300,
                            overflowY: "auto",
                            borderRadius: "sm",
                            children: ((results === null || results === void 0 ? void 0 : results.hits) || []).filter(function(hit) {
                                return !selectedItems.find(function(tag) {
                                    return hit.slug === tag.value;
                                });
                            }).map(function(hit, index) {
                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                    as: "li"
                                }, getItemProps({
                                    item: {
                                        name: hit.name,
                                        value: hit.slug
                                    }
                                })), {
                                    color: highlightedIndex === index ? "blue.600" : "gray.900",
                                    px: 4,
                                    pl: 6,
                                    py: 2,
                                    fontSize: "sm",
                                    _hover: {
                                        color: "blue.600"
                                    },
                                    cursor: "pointer",
                                    children: hit.name
                                }), hit.slug);
                            })
                        }))
                    })
                ]
            });
        }
    }));
};


/***/ }),

/***/ 32025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTagsFilter; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/shared/graphql/ListTagsBySlugsQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ListTagsBySlugs($slugs: [String!]!) {\n    listTagsBySlugs(slugs: $slugs) {\n      name\n      slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ListTagsBySlugsQuery = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./src/shared/hooks/useTagsFilter.tsx


function useTagsFilter(param) {
    var tags = param.tags;
    var ref = (0,useQuery/* useQuery */.a)(ListTagsBySlugsQuery, {
        variables: {
            slugs: tags
        },
        skip: tags.length === 0
    }), data = ref.data, loading = ref.loading;
    return {
        tags: loading ? [] : (data === null || data === void 0 ? void 0 : data.listTagsBySlugs.map(mapTagToFilterOption)) || [],
        loading: loading
    };
};
function mapTagToFilterOption(tag) {
    return {
        value: tag.slug,
        name: tag.name
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,4047,9932,2670,9774,2888,179], function() { return __webpack_exec__(78741); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);